export default "__VITE_ASSET__DcAz89VR__"